module.exports = __webpack_public_path__ + "img/greg_mancz.5551045d.png";